var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("header", [_c("Breadcrumb")], 1)
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(_vm.$t("get.status")) + ":")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.StatusId
                          ? _vm.$t("insert.active")
                          : _vm.$t("insert.passive")
                      )
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("get.RMA.RMA"), active: "" } },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Customer,
                                "object",
                                "get.RMA.Customer"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Warehouse,
                                "object",
                                "get.RMA.Warehouse"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Representative,
                                "object",
                                "get.RMA.Representative"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.RmaStatus,
                                "object",
                                "get.RMA.RmaStatus"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ApproveEmployee,
                                "object",
                                "get.RMA.ApproveEmployee"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ApproveNumber,
                                "text",
                                "get.RMA.ApproveNumber"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.RmaType,
                                "object",
                                "get.RMA.RmaType"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ApproveDate,
                                "date",
                                "get.RMA.ApproveDate"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.PriceDate,
                                "date",
                                "get.RMA.PriceDate"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Genexp1,
                                "text",
                                "get.RMA.Genexp1"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.RmaDate,
                                "date",
                                "get.RMA.RmaDate"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.GrvNumber,
                                "text",
                                "get.RMA.GrvNumber"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Route,
                                "object",
                                "get.RMA.Route"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.RmaReason,
                                "object",
                                "get.RMA.RmaReason"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-4 asc__showPage-card" },
                          [
                            _c("NextExportDetail", {
                              attrs: {
                                url: "VisionNextRma/api/Rma/ExcelExportItems",
                                "record-id": _vm.rowData.RecordId,
                                "record-key": "rmaId",
                                "file-name": _vm.$t("get.RMA.Items")
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("insert.RMA.Item"))
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("insert.RMA.ItemName"))
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.RMA.lastSalesQuantity"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("insert.RMA.Quantity"))
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.RMA.UsedQuantity")
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("insert.RMA.usedPrice"))
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  _vm._l(
                                    _vm.rowData.RmaLines != null
                                      ? _vm.rowData.RmaLines.filter(function(
                                          f
                                        ) {
                                          return f.RecordState !== 4
                                        })
                                      : [],
                                    function(w, i) {
                                      return _c(
                                        "b-tr",
                                        { key: i },
                                        [
                                          _c("b-td", [
                                            _vm._v(_vm._s(w.Item.Code))
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(w.Item.Label))
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(w.LastSalesQuantity))
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(w.Quantity))
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(w.UsedQuantity))
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [_vm._v(_vm._s(w.Price))])
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0708404e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0708404e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Rma/get.vue
// module id = null
// module chunks = 